import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from '@react-pdf/renderer';
import ibmLogo from '../assets/images/logo.png';
import { roiCookieContent } from './MASROIEstimator';
import { useCurrency } from 'src/common/hooks/widgets/useCurrency';

export interface MASROIEstimatorProps {
  imgSummary: string;
  imgSummary1: string;
  cookieContent: roiCookieContent;

  dataInputTitles: string[];
  currency: string;
  userLocale: string;
}
export const PDFGenerate = ({
  imgSummary,
  imgSummary1,
  cookieContent,
  dataInputTitles,
  currency,
  userLocale,
}: MASROIEstimatorProps) => {
  const styles = StyleSheet.create({
    page: { backgroundColor: '#f4f4f4', paddingTop: 30 },
    section: {
      fontSize: 10,
      textAlign: 'justify',
      width: 500,
      marginLeft: 50,
      marginRight: 50,
    },
    viewFlex: {
      display: 'flex',
      flexDirection: 'row',
      paddingTop: 10,
    },
    viewFlex1: {
      display: 'flex',
      lineHeight: 2.2,
      flexDirection: 'row',
    },
    textInputs: {
      fontSize: 8,
      lineHeight: 1.5,
      width: 100,
      marginTop: 5,
      textAlign: 'center',
    },
    valueInputs: {
      backgroundColor: '#D3D3D3',
      width: 100,
      textAlign: 'center',
      paddingTop: 5,
    },
    textTotal: {
      backgroundColor: '#D3D3D3',
      color: 'blue',
      width: 100,
      lineHeight: 2,
      paddingTop: 5,
      textAlign: 'center',
      height: 25,
    },
    paragraph: { paddingTop: 10, paddingBottom: 10 },
    paragraph1: { paddingTop: 30 },
    title: { paddingTop: 20, fontSize: 12 },
    paragraphItalics: { fontStyle: 'italic', paddingTop: 20 },
    image: { width: 50, height: 20 },
    imageForResults: {
      width: 420,
      height: 'auto',
    },
    imageForSummary: {
      width: 420,
      height: 'auto',
      marginTop: 40,
    },
  });

  Font.registerHyphenationCallback((word) => [word]);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={[styles.section]}>
          <Image style={styles.image} src={ibmLogo} />
          <Text style={styles.title}>
            Maximo Application Suite (MAS) Benefit Estimator
          </Text>
        </View>
        <View style={[styles.section, { marginTop: 15 }]}>
          <Image style={styles.imageForResults} src={imgSummary1} />
        </View>
      </Page>
      <Page size="A4" style={styles.page}>
        <View style={[styles.section]}>
          <Image style={styles.image} src={ibmLogo} />

          <Image style={styles.imageForSummary} src={imgSummary} />

          <Text style={[styles.title, { marginTop: 30 }]}>
            {dataInputTitles[14]}
          </Text>
          <Text style={styles.paragraph}>{dataInputTitles[21]}</Text>
          <View style={styles.viewFlex}>
            <View>
              <View style={styles.viewFlex1}>
                <Text style={styles.valueInputs}>
                  {cookieContent.input.maintenanceFTEs.toString()}
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}>
                  {cookieContent.input.maintenancePersonProd.toString()}%
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}>
                  {useCurrency(
                    currency,
                    userLocale,
                    cookieContent.input.maintenanceAnnualFTERate,
                  )}
                </Text>
              </View>
              <View style={styles.viewFlex1}>
                <Text style={styles.textInputs}>{dataInputTitles[0]}</Text>
                <Text> </Text>
                <Text> </Text>
                <Text> </Text>
                <Text style={styles.textInputs}>{dataInputTitles[1]}</Text>
                <Text> </Text>
                <Text> </Text>
                <Text> </Text>
                <Text style={styles.textInputs}>{dataInputTitles[2]}</Text>
              </View>
            </View>
            <Text> </Text>
            <Text> </Text>
            <Text> = </Text>
            <View style={styles.textTotal}>
              <Text>{cookieContent.MaintenanceTotal}</Text>
            </View>
          </View>
          <Text style={styles.title}>{dataInputTitles[15]}</Text>
          <Text style={styles.paragraph}>{dataInputTitles[22]}</Text>
          <View style={styles.viewFlex}>
            <View>
              <View style={styles.viewFlex1}>
                <Text style={styles.valueInputs}>
                  {useCurrency(
                    currency,
                    userLocale,
                    cookieContent.input.extMaintenanceVendSpend,
                  )}
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}>
                  {cookieContent.input.extMaintenanceVendSpendReduce.toString()}
                  %
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}></Text>
              </View>
              <View style={styles.viewFlex1}>
                <Text style={styles.textInputs}>{dataInputTitles[3]}</Text>
                <Text> </Text>
                <Text> </Text>
                <Text> </Text>
                <Text style={styles.textInputs}>{dataInputTitles[4]}</Text>
              </View>
            </View>
            <Text> </Text>
            <Text> </Text>
            <Text> = </Text>
            <View style={styles.textTotal}>
              <Text>{cookieContent.ReduceExtMaintTotal}</Text>
            </View>
          </View>
        </View>
      </Page>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Image style={styles.image} src={ibmLogo} />
          <Text style={styles.title}>{dataInputTitles[16]}</Text>
          <Text style={styles.paragraph}>{dataInputTitles[23]}</Text>
          <View style={styles.viewFlex}>
            <View>
              <View style={styles.viewFlex1}>
                <Text style={styles.valueInputs}>
                  {cookieContent.input.downTimeHours.toString()}
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}>
                  {cookieContent.input.downTimeReduce.toString()}%
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}>
                  {useCurrency(
                    currency,
                    userLocale,
                    cookieContent.input.downTimeCostPerHour,
                  )}
                </Text>
              </View>
              <View style={styles.viewFlex1}>
                <Text style={styles.textInputs}>{dataInputTitles[5]}</Text>
                <Text> </Text>
                <Text> </Text>
                <Text> </Text>
                <Text style={styles.textInputs}>{dataInputTitles[6]}</Text>
                <Text> </Text>
                <Text> </Text>
                <Text> </Text>
                <Text style={styles.textInputs}>{dataInputTitles[7]}</Text>
              </View>
            </View>
            <Text> </Text>
            <Text> </Text>
            <Text> = </Text>
            <View style={styles.textTotal}>
              <Text>{cookieContent.ReduceDowntimeCostTotal}</Text>
            </View>
          </View>
          <Text style={styles.title}>{dataInputTitles[18]}</Text>
          <Text style={styles.paragraph}>{dataInputTitles[25]}</Text>
          <View style={styles.viewFlex}>
            <View>
              <View style={styles.viewFlex1}>
                <Text style={styles.valueInputs}>
                  {useCurrency(
                    currency,
                    userLocale,
                    cookieContent.input.mroSpend,
                  )}
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}>
                  {cookieContent.input.mroOverSpendReduce.toString()}%
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}></Text>
              </View>
              <View style={styles.viewFlex1}>
                <Text style={styles.textInputs}>{dataInputTitles[8]}</Text>
                <Text> </Text>
                <Text> </Text>
                <Text> </Text>
                <Text style={styles.textInputs}>{dataInputTitles[9]}</Text>
              </View>
            </View>
            <Text> </Text>
            <Text> </Text>
            <Text> = </Text>
            <View style={styles.textTotal}>
              <Text>{cookieContent.IncreaseMROTotal}</Text>
            </View>
          </View>
          <Text style={styles.title}>{dataInputTitles[17]}</Text>
          <Text style={styles.paragraph}>{dataInputTitles[24]}</Text>
          <View style={styles.viewFlex}>
            <View>
              <View style={styles.viewFlex1}>
                <Text style={styles.valueInputs}>
                  {useCurrency(
                    currency,
                    userLocale,
                    cookieContent.input.replaceAssetBudget,
                  )}
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}>
                  {cookieContent.input.assetsLifeExtension.toString()}%
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}></Text>
              </View>
              <View style={styles.viewFlex1}>
                <Text style={styles.textInputs}>{dataInputTitles[10]}</Text>
                <Text> </Text>
                <Text> </Text>
                <Text> </Text>
                <Text style={styles.textInputs}>{dataInputTitles[11]}</Text>
              </View>
            </View>
            <Text> </Text>
            <Text> </Text>
            <Text> = </Text>
            <View style={styles.textTotal}>
              <Text>{cookieContent.ExtendAssetLifeTotal}</Text>
            </View>
          </View>
          <Text style={styles.title}>{dataInputTitles[19]}</Text>
          <Text style={styles.paragraph}>{dataInputTitles[26]}</Text>
          <View style={styles.viewFlex}>
            <View>
              <View style={styles.viewFlex1}>
                <Text style={styles.valueInputs}>
                  {useCurrency(
                    currency,
                    userLocale,
                    cookieContent.input.assetMgmtToolCost,
                  )}
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}>
                  {cookieContent.input.assetMgmtCostReduce.toString()}%
                </Text>
                <Text> x </Text>
                <Text style={styles.valueInputs}></Text>
              </View>
              <View style={styles.viewFlex1}>
                <Text style={styles.textInputs}>{dataInputTitles[12]}</Text>
                <Text> </Text>
                <Text> </Text>
                <Text> </Text>
                <Text style={styles.textInputs}>{dataInputTitles[13]}</Text>
              </View>
            </View>
            <Text> </Text>
            <Text> </Text>
            <Text> = </Text>
            <View style={styles.textTotal}>
              <Text>{cookieContent.AssetMgmtToolsTotal}</Text>
            </View>
          </View>
        </View>
        <View style={styles.section}>
          <Text style={styles.paragraph1}>{dataInputTitles[20]}</Text>
        </View>
      </Page>
    </Document>
  );
};
